import { tryParseJsonObject } from '../../../../infrastructure/helpers/common/json';
import DragData from '../../../../types/report/DragData';
import './DraggableItem.scss';
import React from 'react';

interface Props {
    identifier: number;
    onDrop: (dragIdentifier: number, dropIdentifier: number, event: React.DragEvent<HTMLDivElement>, dragSpecialData?:string, dropSpecialData?: string) => void;
    style?: React.CSSProperties;
    specialData?: string;
    className?: string;
}

const transferData = 'transferData';

class DraggableItem extends React.Component<Props, {className:string}> {

    constructor(props: Props) {
        super(props);

        this.state = {
            className:''
        }

        this.onDragStart = this.onDragStart.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
    }

    onDragStart(e: React.DragEvent<HTMLDivElement>, identifier: number, specialData?: string): void {
        e.dataTransfer.items.add('dragNumber', identifier.toString());
        e.dataTransfer.setData(transferData, JSON.stringify({ dragIdentifier: identifier.toString(), specialData: specialData }));
    }

    onDrop(e: React.DragEvent<HTMLDivElement>, identifier: number, dropSpecialData?: string): void {

        this.setState({ className: 'not-highlight' });

        let data = tryParseJsonObject<DragData>(e.dataTransfer.getData(transferData));

        if (data.dragIdentifier) {
            let dragIdentifier = parseInt(data.dragIdentifier);

            this.props.onDrop(dragIdentifier, identifier, e, data.specialData, dropSpecialData);
        }
    }

    onDragOver(e: React.DragEvent<HTMLDivElement>): void {
        this.setState({ className: 'highlight' });
        e.preventDefault();
    }

    onDragLeave(e: React.DragEvent<HTMLDivElement>): void {
        this.setState({ className: 'not-highlight' });
    }

    render(): JSX.Element {
        return (
            <div
                className={`draggable-item ${this.state.className} ${this.props.className || ''}`}
                draggable={true}
                onDragStart={e => this.onDragStart(e, this.props.identifier, this.props.specialData)}
                onDrop={e => this.onDrop(e, this.props.identifier, this.props.specialData)}
                onDragOver={this.onDragOver}
                onDragLeave={this.onDragLeave }
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export default DraggableItem;